'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _memoizeOne = require('react-utils/memoizeOne');

var _memoizeOne2 = _interopRequireDefault(_memoizeOne);

var _UIClickable = require('../button/UIClickable');

var _UIClickable2 = _interopRequireDefault(_UIClickable);

var _decorators = require('../utils/propTypes/decorators');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var getStyle = function getStyle(style, centerContent, width) {
  return centerContent ? _extends({}, style, { maxWidth: width }) : style;
};

var USE_CLASSES = {
  dark: '',
  light: 'private-overlay--light'
};

var UIOverlay = function (_React$Component) {
  _inherits(UIOverlay, _React$Component);

  function UIOverlay(props) {
    _classCallCheck(this, UIOverlay);

    var _this = _possibleConstructorReturn(this, (UIOverlay.__proto__ || Object.getPrototypeOf(UIOverlay)).call(this, props));

    _this.handleClick = function (evt) {
      var onClick = _this.props.onClick;

      if (onClick) onClick(evt);
    };

    _this._getStyle = (0, _memoizeOne2.default)(getStyle);
    return _this;
  }

  _createClass(UIOverlay, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          centerContent = _props.centerContent,
          children = _props.children,
          className = _props.className,
          contextual = _props.contextual,
          onClick = _props.onClick,
          style = _props.style,
          tabIndex = _props.tabIndex,
          use = _props.use,
          width = _props.width,
          Inner = _props.Inner,
          rest = _objectWithoutProperties(_props, ['centerContent', 'children', 'className', 'contextual', 'onClick', 'style', 'tabIndex', 'use', 'width', 'Inner']);

      var isSandboxed = contextual || this.context.sandboxed;

      var computedClassName = (0, _classnames2.default)(className, 'private-overlay', 'uiOverlay-backdrop', USE_CLASSES[use], {
        'private-overlay--contextual': isSandboxed
      });

      var computedChildrenWrapperClassName = (0, _classnames2.default)({
        'private-modal__container': centerContent
      });

      var isClickable = onClick;
      var Overlay = isClickable ? _UIClickable2.default : 'div';
      var overlayProps = isClickable ? { cursor: 'auto' } : undefined;

      return _react2.default.createElement(
        Overlay,
        _extends({}, rest, overlayProps, {
          className: computedClassName,
          onClick: this.handleClick,
          role: 'presentation',
          tabIndex: isSandboxed ? null : tabIndex
        }),
        _react2.default.createElement(
          Inner,
          {
            className: computedChildrenWrapperClassName,
            ref: function ref(_ref) {
              _this2._innerEl = (0, _reactDom.findDOMNode)(_ref);
            },
            style: this._getStyle(style, centerContent, width)
          },
          children
        )
      );
    }
  }]);

  return UIOverlay;
}(_react2.default.Component);

UIOverlay.propTypes = {
  centerContent: _propTypes2.default.bool.isRequired,
  children: _propTypes2.default.node,
  contextual: _propTypes2.default.bool.isRequired,
  use: _propTypes2.default.oneOf(Object.keys(USE_CLASSES)),
  width: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]).isRequired,
  Inner: (0, _decorators.hidden)(_propTypes2.default.elementType)
};

UIOverlay.contextTypes = {
  sandboxed: _propTypes2.default.bool
};

UIOverlay.defaultProps = {
  centerContent: true,
  contextual: false,
  use: 'dark',
  Inner: 'div'
};

UIOverlay.displayName = 'UIOverlay';

exports.default = UIOverlay;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3620/js/overlay/UIOverlay.js
// module id = 548
// module chunks = 177